import { useCallback } from 'react'
import { i18n } from '@fs/zion-locale'

export default function useIntlDateTime() {
  const { language } = i18n
  const formatDate = useCallback(
    ({
      date,
      options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      },
    }) => {
      if (date == null) return null
      return new Intl.DateTimeFormat(language, options).format(date)
    },
    [language]
  )
  return formatDate
}
